import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import InfoChip from 'components/shared/InfoChip';
import Tooltip from 'components/shared/Tooltip';
import LocationEpisode from 'models/LocationEpisode';
import colors from 'styles/theme/colors';

type Props = {
  locationEpisode: LocationEpisode;
};

export default function PatientClassifications({ locationEpisode }: Props) {
  return (
    <ChipContainer data-cy='planAndEpisodeLabels'>
      {!!locationEpisode.planTypeClassification?.name && (
        <HoverableChip
          textValue={`Plan Type: ${locationEpisode.planTypeClassification.name}`}
          backgroundColor='#E7F5FB'
          color='#085272'
        />
      )}
      {locationEpisode.episodeClassifications.map((ec) => (
        <HoverableChip
          key={ec.id}
          textValue={`Episode Type: ${ec.name}`}
          backgroundColor={colors.black05}
          color={colors.black75}
        />
      ))}
    </ChipContainer>
  );
}

const HoverableChip = ({
  textValue,
  backgroundColor,
  color,
}: {
  textValue: string;
  backgroundColor: string;
  color: string;
}) => {
  const [renderTooltip, setRenderTooltip] = useState(false);
  const chipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (chipRef.current) {
      const rect = chipRef.current.getBoundingClientRect();
      setRenderTooltip(rect.width >= 240);
    }
  }, [chipRef]);

  return (
    <Tooltip text={textValue} position='bottom' disabled={!renderTooltip}>
      <InfoChip ref={chipRef} $backgroundColor={backgroundColor} $color={color} $maxWidth={240}>
        {textValue}
      </InfoChip>
    </Tooltip>
  );
};

const ChipContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;
`;
